import { render, staticRenderFns } from "./TrafficView.vue?vue&type=template&id=0fa0b2dc"
import script from "./TrafficView.vue?vue&type=script&lang=js"
export * from "./TrafficView.vue?vue&type=script&lang=js"
import style0 from "./TrafficView.vue?vue&type=style&index=0&id=0fa0b2dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports